import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/returns.scss";

function Returns() {
  const email = siteConfig.contact?.email;
  const returnWindow = siteConfig.returns?.windowDays || 14;

  return (
    <main className="service-page returns-page">
      <header className="service-hero">
        <p className="service-kicker">SERVICE / RETURNS &amp; EXCHANGES</p>
        <h1>Give it a proper try.</h1>
        <p>
          If the fit is not right, unworn items may be returned within {returnWindow} days
          of delivery. Keep the tags attached and the garment in original
          condition.
        </p>
      </header>

      <section className="service-highlights" aria-label="Return policy highlights">
        <div>
          <strong>{returnWindow}</strong>
          <span>Days from delivery</span>
        </div>
        <div>
          <strong>01</strong>
          <span>Original condition</span>
        </div>
        <div>
          <strong>5–10</strong>
          <span>Days for refunds</span>
        </div>
      </section>

      <div className="service-layout">
        <aside className="service-steps" aria-labelledby="return-steps-title">
          <p className="service-kicker">START A RETURN</p>
          <h2 id="return-steps-title">Three straightforward steps.</h2>
          <ol>
            <li>
              <span>01</span>
              <p>Contact us with your order number and the item being returned.</p>
            </li>
            <li>
              <span>02</span>
              <p>Pack the unworn item securely with its tags and original packaging.</p>
            </li>
            <li>
              <span>03</span>
              <p>Use a tracked service and keep the receipt until processing is complete.</p>
            </li>
          </ol>
          <div className="service-action-row">
            <Link to="/contact">Start a return</Link>
            {email && <a href={`mailto:${email}`}>Email service</a>}
          </div>
        </aside>

        <article className="service-copy">
          <section>
            <span>ELIGIBILITY</span>
            <h2>What can be returned</h2>
            <p>
              Items must be unworn, unwashed, unaltered and free from scent,
              marks or damage. All original tags must remain attached. Returns
              that show wear or arrive outside the return window may be declined.
            </p>
          </section>
          <section>
            <span>FINAL SALE</span>
            <h2>Exceptions</h2>
            <p>
              Final-sale items, gift cards and goods marked non-returnable at
              purchase cannot be returned. For hygiene reasons, opened personal
              items are also excluded unless faulty.
            </p>
          </section>
          <section>
            <span>REFUNDS</span>
            <h2>Inspection and repayment</h2>
            <p>
              Approved refunds are sent to the original payment method after
              inspection. Your bank may need additional time to post the credit.
              Original shipping fees and duties are not refundable unless the
              item was incorrect or faulty.
            </p>
          </section>
          <section>
            <span>EXCHANGES</span>
            <h2>Need another size?</h2>
            <p>
              The quickest exchange is to return the original piece and place a
              new order. This avoids stock being held while a parcel is in transit.
            </p>
          </section>
          <section>
            <span>DAMAGED / INCORRECT</span>
            <h2>We will make it right</h2>
            <p>
              Contact us promptly with your order number and clear photos. We
              will review the issue and provide the appropriate next step.
            </p>
          </section>
        </article>
      </div>
    </main>
  );
}

export default Returns;
